//Node Modules
import { useCallback } from "react";
import { API } from "aws-amplify";
import { useSetRecoilState } from "recoil";

//Atoms
import { dialogAtomFamily } from "../atoms/dialog";

//Helpers
import { useLogout } from "./Auth";

export const useApiRequest = () => {
	const apiName = "steeperApi";
	const handleLogout = useLogout();
	const setLoading = useSetRecoilState(dialogAtomFamily("loadingDialog"));

	const makeRequest = useCallback(async (verb = "get", endpoint, body, message) => {
		console.log("Calling ::", `${verb.toUpperCase()} ${endpoint}`, `Body: ${body}`);

		const customInit = {
			body,
		};

		try {
			message && setLoading({ visible: true, message: message });
			const response = await API[verb](apiName, endpoint, customInit);
			console.log("useApiRequest Response Data ::", response);
			return response;
		} catch (err) {
			console.error("useApiRequestError:", err);
			if (err.code === "NotAuthorizedException" || err === "No current user") {
				handleLogout();
			} else if (err.response) {
				throw err;
			}
		} finally {
			setLoading({ visible: false, message: "" });
		}
	}, []);

	return makeRequest;
};
